// //////////////////////////////////////////////////////////////////////////////////////
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Title, Grid } from '../../components/index';

/* Grid, Input, Modal, Title */
class DadosHistoricoPrescricao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // prescricoes: [],
    };
  }

  montaDadosPrescricao = () => (
    // const mock = this.prescricaoMock;
    <React.Fragment>
      <li>
        <div className="row">
          <Grid cols="12 3">
            <Title
              title="Pró-rata no 1º pagamento:"
              type="section"
              fontWeight="regular-16"
            />
            <p>R${this.props.estadoFormulario.requerimento.prescricao.vlProRataPrescricao}</p>
          </Grid>
          <Grid cols="12 3">
            <Title
              title="Valor Total Prescrito:"
              type="section"
              fontWeight="regular-16"
            />
            <p>R${this.props.estadoFormulario.requerimento.prescricao.vlTotalPrescricao}</p>
          </Grid>
          <Grid cols="12 3">
            <Title
              title="Qtde de Dias Prescritos:"
              type="section"
              fontWeight="regular-16"
            />
            <p>{this.props.estadoFormulario.requerimento.prescricao.qtdeDiasPrescritos}</p>
          </Grid>
        </div>

        <div className="row">
          <Grid cols="12 3">
            <Title
              title="Estoque:"
              type="section"
              fontWeight="regular-16"
            />
            <p>R${this.props.estadoFormulario.requerimento.prescricao.vlEstoquePrescricao}</p>
          </Grid>

          <Grid cols="12 3">
            <Title
              title="13º de estoque:"
              type="section"
              fontWeight="regular-16"
            />
            <p>R${this.props.estadoFormulario.requerimento.prescricao.vl13EstoquePrescricao}</p>
          </Grid>

          <Grid cols="12 3">
            <Title
              title="Início da prescrição do estoque:"
              type="section"
              fontWeight="regular-16"
            />
            <p>{this.props.estadoFormulario.requerimento.prescricao.dtIniPeriodoEstoquePrescricao}</p>
          </Grid>

          <Grid cols="12 3">
            <Title
              title="Fim da prescrição do estoque:"
              type="section"
              fontWeight="regular-16"
            />
            <p>{this.props.estadoFormulario.requerimento.prescricao.dtFimPeriodoEstoquePrescricao}</p>
          </Grid>
        </div>

        <div className="row">
          <Grid cols="12 3">
            <Title
              title="Fluxo acumulado:"
              type="section"
              fontWeight="regular-16"
            />
            <p>R${this.props.estadoFormulario.requerimento.prescricao.vlPassivoPrescricao}</p>
          </Grid>

          <Grid cols="12 3">
            <Title
              title="13º de fluxo acumulado:"
              type="section"
              fontWeight="regular-16"
            />
            <p>R${this.props.estadoFormulario.requerimento.prescricao.vl13PassivoPrescricao}</p>
          </Grid>

          <Grid cols="12 3">
            <Title
              title="Início da prescrição do fluxo:"
              type="section"
              fontWeight="regular-16"
            />
            <p>{this.props.estadoFormulario.requerimento.prescricao.dtIniPeriodoPassivoPrescricao}</p>
          </Grid>

          <Grid cols="12 3">
            <Title
              title="Fim da prescrição do fluxo:"
              type="section"
              fontWeight="regular-16"
            />
            <p>{this.props.estadoFormulario.requerimento.prescricao.dtFimPeriodoPassivoPrescricao}</p>
          </Grid>
        </div>

      </li>
    </React.Fragment>
  );

  render() {
    return (
      <React.Fragment>
        <ol>{this.montaDadosPrescricao()}</ol>
      </React.Fragment>
    );
  }
}

DadosHistoricoPrescricao.propTypes = {
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
};
export default DadosHistoricoPrescricao;
// //////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/pages/requerimentos/DadosHistoricoPrescricao.jsx